import classnames from "classnames"
import Styles from "./NotificationCard.module.scss";
import { DEVICE_TYPE } from "../../constants/constants";
import { useDispatch } from "react-redux";
import { openWindow } from "../../actions";
import { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";

interface NotificationCardProps {
    id:string;
    appId: string;
    mobileAppId:string;
    appName: string;
    title: string;
    subText: string;
    time: string;
    deviceType?: DEVICE_TYPE.MOBILE | DEVICE_TYPE.DESKTOP;
    bannerImage?: string;
    visitLink?: string;
}

const NotificationCard = (
    {
        id,
        appId,
        mobileAppId,
        appName,
        title,
        subText,
        time,
        deviceType = DEVICE_TYPE.DESKTOP,
        bannerImage = "",
        visitLink = ""
    }: NotificationCardProps
) => {


    const {isMObile } =useContext(AppContext)

    const dispatch = useDispatch()


    const handleClick = () => {
        const newWindow = window.open(visitLink, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        <div className={classnames(Styles.container, Styles[deviceType])} onClick={visitLink ? handleClick : () => { dispatch(openWindow(isMObile ? mobileAppId : appId)) }} >
            <div className={Styles.header}>
                <div className={Styles.icon} id={appId} />
                <div className={Styles.app_name}>{appName}</div>
                <div className={Styles.time}>{time}</div>
            </div>
            {
                deviceType === DEVICE_TYPE.MOBILE && <div style={{ borderRadius: "50%" }} className={Styles.mobile_notification_icon}>
                    <div className={Styles.icon} id={DEVICE_TYPE.MOBILE?mobileAppId:appId} />
                </div>
            }
            <div className={Styles.content}>
                <div className={Styles.title}>
                    {title}
                </div>
                <div className={Styles.sub_text}>
                    {subText}
                </div>
            </div>

            {
                deviceType === DEVICE_TYPE.MOBILE && bannerImage && <div className={Styles.mobile_notification_icon}>
                    <img src={bannerImage} />
                </div>
            }
        </div>
    )
}

export default NotificationCard
